export const BUILD_NUMBER = __BUILD_NUMBER__;
export const BUILD_PREFIX = `/${BUILD_NUMBER}`;

export function withBuildPrefix(path = '/') {
  const logical = path.startsWith('/') ? path : `/${path}`;
  if (logical === BUILD_PREFIX || logical.startsWith(`${BUILD_PREFIX}/`)) return logical;
  return `${BUILD_PREFIX}${logical}`;
}

export function withoutBuildPrefix(path = '/') {
  if (path === BUILD_PREFIX) return '/';
  return path.startsWith(`${BUILD_PREFIX}/`) ? path.slice(BUILD_PREFIX.length) : path;
}

export function isDraftPath(path = window.location.pathname) {
  return withoutBuildPrefix(path).replace(/\/+$/, '').startsWith('/drafts');
}

export function browserUrl(value = '') {
  if (!value || /^(?:[a-z]+:|#|\/\/)/i.test(value)) return value;
  return value.startsWith('/') ? withBuildPrefix(value) : value;
}

export function prefixLogicalHtml(value = '') {
  return String(value).replace(/\b(src|href)=(['"])(\/[^'"]*)\2/gi,
    (_match, attribute, quote, path) => `${attribute}=${quote}${browserUrl(path)}${quote}`);
}
